import styled from 'styled-components';
import theme from '../../assets/styles/theme';

const FilterChipsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${theme.spacing['spacing-8']};
`;

const FiltersChips = styled.div`
  display: flex;
  margin-left: ${theme.spacing['spacing-4']};
  margin-right: ${theme.spacing['spacing-5']};
`;

const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const AdvancedFiltersPopper = styled.div`
  position: absolute;
  z-index: 10;
  box-shadow: ${theme.elevations['elevation-3']};
  ${(props) => (props.invertPosition ? 'right: 0' : 'left: 0')}
`;

const AdvancedButtonWrapper = styled.div`
  position: relative;
  align-self: flex-end;
`;

const AdvancedFiltersWrapper = styled.div`
  width: 550px;
`;

const AdvancedFiltersHeader = styled.div``;

const AdvancedFiltersBody = styled.div`
  padding-top: ${theme.spacing['spacing-6']};
`;

const AdvancedFiltersButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  margin-top: ${theme.spacing['spacing-7']};
  button:first-child {
    margin-right: ${theme.spacing['spacing-5']};
  }
`;

const FiltersWrapper = styled.div`
  margin-right: ${theme.spacing['spacing-4']};
`;

const FilterChipWrapper = styled.div`
  margin-right: ${theme.spacing['spacing-4']};
`;

export {
  FilterChipsWrapper,
  AdvancedFiltersPopper,
  AdvancedFiltersWrapper,
  AdvancedFiltersHeader,
  AdvancedFiltersBody,
  AdvancedFiltersButtons,
  FiltersChips,
  FilterWrapper,
  FiltersWrapper,
  FilterChipWrapper,
  AdvancedButtonWrapper,
};
